<template>
  <md-card class="md-card-login" :class="{ 'md-card-hidden': cardHidden }">
    <md-card-content>
      <slot name="description"></slot>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "light-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cardHidden: true,
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function () {
      this.cardHidden = false;
    },
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>

<style lang="css">
.md-card-login {
  margin-top: 8px !important;
}

.md-card-content {
  color: #999999;
}
</style>
